export enum CountryEnum {
  AT = 40, //    Österreich
  BE = 56, //    Belgien
  CZ = 203, //   Tschechien
  DK = 208, //   Dänemark
  FR = 250, //   Frankreich
  DE = 276, //   Deutschland
  IT = 380, //   Italien
  LI = 438, //   Liechtenstein
  LU = 442, //   Luxemburg
  NL = 528, //   Niederlande
  PL = 616, //   Polen
  ES = 724, //   Spanien
  CH = 756, //   Schweiz
}


/*
* case 203:
        l_result = EZipCodeRule.Fuenfstellig;
        break;
        case 250:
        l_result = EZipCodeRule.Fuenfstellig;
        break;
        case 276:
        l_result = EZipCodeRule.Fuenfstellig;
        break;
        case 380:
        l_result = EZipCodeRule.Fuenfstellig;
        break;
        case 724:
        l_result = EZipCodeRule.Fuenfstellig;
        break;
        case 438:
        l_result = EZipCodeRule.Vierstellig;
        break;
        case 442:
        l_result = EZipCodeRule.Vierstellig;
        break;
        case 208:
        l_result = EZipCodeRule.Vierstellig;
        break;
        case 40:
        l_result = EZipCodeRule.Vierstellig;
        break;
        case 56:
        l_result = EZipCodeRule.Vierstellig;
        break;
        case 616:
        l_result = EZipCodeRule.FuenfstelligAufPositionDreimitBindeStrichGetrennt;
        break;
        case 528:
        l_result = EZipCodeRule.AlphaFormat123UnderscoreAB;
        break;
        case 756:
        l_result = EZipCodeRule.VierOderSechsstellig;
        break;
* */
